import React from "react";
import { useParams } from "react-router";
import LenderUgroService from "../../../../services/lender";
import { Context } from "../../../../config/store";
import Table from "../../../../components/Common/Table";
import RepaymentModal from "./RepaymentModal";
import TableNoRecords from "../../../../components/Common/Table/TableNoRecords";
import './styles.css'
import { Borrower, Sourcing, Lending, Lender, LenderRPS } from './TableColumns'
import { downloadFile } from "../../../../common/download";
import { toast } from "react-toastify";
import FetchRepaymentModal from "./FetchRepatmentModal";

export default function RepaymentSchedule({ selectedLender, selectedLenderName }) {
  const { state } = React.useContext(Context);
  const leadId = useParams().id;

  const [tableData, setTableData] = React.useState([]);
  const [tableLenderData, setTableLenderData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [activeTab, setActiveTab] = React.useState('Customer') // Borrower
  const [repaymentType, setRepaymentType] = React.useState('UGRO')
  const [showDropDown, setDropDownStatus] = React.useState(false);
  const [showFetchRpsModal, setShowFetchRpsModal] = React.useState(false);
  const [modalState, setModalState] = React.useState(false);
  const dropdownRef = React.useRef()
  const [rpsConfig, setRpsConfig] = React.useState({})

  React.useLayoutEffect(() => {
    if (repaymentType === "UGRO") {
      getPaymentList()
    } else {
      getLenderRePaymentList()
    }
  }, [activeTab, repaymentType])

  const toggleModal = () => {
    setModalState(!modalState)
  }

  const handleExportClick = async (e, type, fileName, lenderType) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response =
        repaymentType === 'UGRO' ?
          await LenderUgroService.downloadRepaymentFile({
            type: type,
            leadId: leadId,
            lenderId: selectedLender,
            dataExport: 1,
            responseType: 'blob',
          })
          :
          await LenderUgroService.downloadLenderRepaymentFile({
            type: lenderType,
            leadId: leadId,
            lenderId: selectedLender,
            dataExport: 1,
            responseType: 'blob',
          })
      downloadFile(response.data, fileName + new Date().toLocaleString());
      toast.success(response?.data?.messages?.error?.others[0])
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error('Download Failed, Please try again')
    }
    setDropDownStatus(!showDropDown)
  }

  const getPaymentList = async () => {
    setLoading(true);
    try {
      const response = await LenderUgroService.getRePaymentList({
        leadId: leadId,
        lenderId: selectedLender
      });
      const data = response?.data?.data?.repayments;
      const configData = response?.data?.data?.rps_config
      data.shift()
      setTableData(data);
      setRpsConfig(configData)
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(
        err.response?.data?.messages?.error?.form[0] ||
        err.response?.data?.messages?.error?.others[0]
      );
    }
  };

  const getLenderRePaymentList = async () => {
    setLoading(true);
    try {
      const response = await LenderUgroService.getLenderRePaymentList({
        leadId: leadId,
        lenderId: selectedLender
      });
      const data = response?.data?.data?.repayment_details;
      setTableLenderData(data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(
        err.response?.data?.messages?.error?.form[0] ||
        err.response?.data?.messages?.error?.others[0]
      );
    }
  };

  React.useEffect(
    () => {
      const listener = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setDropDownStatus(false)
          return;
        } else if(!dropdownRef.current){
          setDropDownStatus(false)
          return;
        } else {
          setDropDownStatus(true)
          return;
        }
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    [dropdownRef]
  );

  const checkHasPermission = checkPermission => {
    if (state.is_super_admin === 1) return true;
    const permission = state.permission.find(
      permission => permission === checkPermission
    );
    if (permission) return true;
    else return false;
  };

  return (
     <>
      <div className="d-flex justify-content-left">
        <div className="repaymentTabsContainer">
          <div
            className={repaymentType === 'UGRO' ? 'tabs active' : 'tabs'}
            onClick={() => {
              setRepaymentType('UGRO');
              setActiveTab('Customer');
            }}
            style={{ cursor: 'pointer', width: 'fit-content', padding: '10px' }}
          >
            UGRO
          </div>
          {selectedLender == 21 && <div
            className={repaymentType === 'LENDER' ? 'tabs active' : 'tabs'}
            onClick={() => {
              setRepaymentType('LENDER');
              setActiveTab('Lender');
            }}
            style={{ cursor: 'pointer', width: 'fit-content', padding: '10px' }}
          >
            {selectedLenderName}
          </div>}
        </div>
      </div>
      <div className="repaymentTopContainer"style={{ marginTop: '0px' }}>
        <div className="repaymentTabsContainer"style={{ marginTop: '8px' }}>
          {!(selectedLender == 21 && repaymentType === 'LENDER') && <><div
            className={activeTab === 'Customer' ? 'tabs active' : 'tabs'}
            onClick={() => { setActiveTab('Customer') }}
            style={{ cursor: 'pointer' }}
          >
            Customer
          </div>
          <div
            className={activeTab === 'Ugro' ? 'tabs active' : 'tabs'}
            onClick={() => { setActiveTab('Ugro') }}
            style={{ cursor: 'pointer' }}
          >
            Ugro
          </div></>}
          <div
            className={activeTab === 'Lender' ? 'tabs active' : 'tabs'}
            onClick={() => { setActiveTab('Lender') }}
            style={{ cursor: 'pointer' }}
          >
            Lender
          </div>
        </div>
        <div className="repaymentRightContainer">
          {(tableLenderData?.[activeTab] || tableData?.length > 0) && <div className="rps_dropdown">
            <div className={`dropdown user-login ${showDropDown ? "show" : ""}`}>
              <button
                className="btn btn-blueButton"
                style={{padding: '0.375rem 0.75rem'}}
                onClick={() => setDropDownStatus(!showDropDown)}
                type="button"
                id="dropdownMenu"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Export
              </button>
              <div
                className={`DropdownLogout dropdown-menu ${showDropDown ? "show" : ""}`}
                aria-labelledby="dropdownMenu"
                style={{left:'0px !important'}}
                ref={dropdownRef}
              >
                <div
                  className={`dropdown-item dropdownItem ${selectedLender == 21 && repaymentType === 'LENDER' ? 'd-none' : ''}`}
                  onClick={(e) => {
                    handleExportClick(e, '1', "All", "All")
                  }}
                  style={{ cursor: 'pointer', width: '100%', display: 'flex' }}
                >
                  All
                </div>
                <div
                  className={`dropdown-item dropdownItem ${selectedLender == 21 && repaymentType === 'LENDER' ? 'd-none' : ''}`}
                  onClick={(e) => {
                    handleExportClick(e, '2', "Customer_RPS_", "Customer")
                  }}
                  style={{ cursor: 'pointer', width: '100%', display: 'flex' }}
                >
                  Customer RPS
                </div>
                <div
                  className={`dropdown-item dropdownItem ${selectedLender == 21 && repaymentType === 'LENDER' ? 'd-none' : ''}`}
                  onClick={(e) => {
                    handleExportClick(e, '4', "Ugro_RPS_", "Ugro")
                  }}
                  style={{ cursor: 'pointer', width: '100%', display: 'flex' }}
                >
                  Ugro RPS
                </div>
                <div
                  className={`dropdown-item dropdownItem`}
                  onClick={(e) => {
                    handleExportClick(e, '3', "Lender_RPS_", "Lender")
                  }}
                  style={{ cursor: 'pointer', width: '100%', display: 'flex' }}
                >
                  Lender RPS
                </div>
              </div>
            </div>
          </div>}
          {/* {repaymentType !== "UGRO" && 
          <div style={{width: '35px'}}></div>
          } */}
          {checkHasPermission("fetch-rps") && repaymentType !== "UGRO" && selectedLender == 21 && <div>
            <button
              className="btn btn-blueButton mr-3 mt-1"
              style={{padding: '0.375rem 0.75rem'}}
              onClick={() => { setModalState(!modalState) }}
            >
              Upload RPS
            </button>
            {modalState && (
              <RepaymentModal
                userType={'lender'}
                state={modalState}
                toggleModal={toggleModal}
                leadId={leadId}
                lenderId={selectedLender}
                reloadTable={getLenderRePaymentList}
              />
            )}
          </div>}
        </div>
      </div>
      {repaymentType === "UGRO" ?
        <div className="repayment_table_css" key={repaymentType}>
          <Table
            columns={activeTab === 'Customer' ? Borrower : activeTab === 'Ugro' ? Sourcing : Lending}
            checkbox={false}
            rows={tableData}
            loading={loading}
            type="paymentData"
          >
            {Boolean(tableData.length < 1) && <TableNoRecords />}
          </Table>
        </div>
        :
        <div className="repayment_table_css" key={repaymentType}>
          <Table
            columns={selectedLender == 21 ? LenderRPS : Lender}
            checkbox={false}
            rows={tableLenderData?.[activeTab]}
            loading={loading}
            type="paymentData"
          >
            {Boolean(tableLenderData?.length < 1 || !tableLenderData?.[activeTab]) && <TableNoRecords />}
          </Table>
        </div>
      }
      {/* {totalElements > pageSize && (
				<Pagination
					size={pageSize}
					currentPage={page}
					totalElements={totalElements}
					updatePage={updateTablePage}
				></Pagination>
			)}  */}
    </>
  );
}